// extracted by mini-css-extract-plugin
export default {"WrapperChat":"WrapperChat_WrapperChat__b0AY+","WrapperMessages":"WrapperChat_WrapperMessages__Iqhcb","loader":"WrapperChat_loader__RGJ7H","l3":"WrapperChat_l3__bDxSV"};